import React from "react";

class HolidayRowNew extends React.Component {

    // Locale datum -> 'YYYY-MM-DD'
    formatDateLocal(date) {
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        if (month.length < 2) {
            month = "0" + month;
        }
        if (day.length < 2) {
            day = "0" + day;
        }

        return year + "-" + month + "-" + day;
    }

    render() {
        const employee = this.props.employee;
        const days = this.props.days || [];
        const workSessions = this.props.workSessions || [];

        // Alleen maandag t/m vrijdag
        const workDays = days.slice(0, 5);

        // Map: datum -> uren
        const hoursByDate = {};
        for (let i = 0; i < workSessions.length; i++) {
            const ws = workSessions[i];
            if (ws && ws.date) {
                hoursByDate[ws.date] = ws.numberOfHours;
            }
        }

        return (
            <div className="holiday-grid-row-simple">

                {/* Naam */}
                <div className="holiday-grid-name">
                    {employee.name}
                </div>

                {/* 5 dagen */}
                {workDays.map((date) => {
                    const iso = this.formatDateLocal(date);
                    const hours = hoursByDate[iso];

                    return (
                        <div key={iso} className="holiday-grid-cell">
                            {hours != null && hours !== 0 ? hours : ""}
                        </div>
                    );
                })}

            </div>
        );
    }
}

export default HolidayRowNew;
